module.exports = __webpack_public_path__ + "img/Stemness-BRCA_GSE176078.5cfec5a9.png";